import { shallowRef } from 'vue';
import { applyBranding } from '@/branding';
import { apiRequest, errorMessage } from '@/api/http';
import { useToast } from './useToast';

// Upload or remove a school image (logo, report banners, sign-in photo).
// Images apply immediately; `busy` holds the kind being changed.
export function useBrandAssets() {
  const toast = useToast();
  const busy = shallowRef('');

  async function upload(kind, file) {
    if (!file) return;
    const body = new FormData();
    body.append('file', file);
    busy.value = kind;
    try {
      applyBranding(await apiRequest('post', `/school-settings/asset/${kind}`, body));
      toast.success('Image updated.');
    } catch (e) {
      toast.error(errorMessage(e, 'Could not upload the image.'));
    } finally {
      busy.value = '';
    }
  }

  // Back to the bundled default, or no image for optional kinds.
  async function reset(kind, { optional = false } = {}) {
    busy.value = kind;
    try {
      applyBranding(await apiRequest('delete', `/school-settings/asset/${kind}`));
      toast.success(optional ? 'Image removed.' : 'Restored the default image.');
    } catch (e) {
      toast.error(errorMessage(e, 'Could not reset the image.'));
    } finally {
      busy.value = '';
    }
  }

  return { busy, upload, reset };
}
